import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alarm',
  templateUrl: './alarm.component.html',
  styleUrls: ['./alarm.component.less']
})
export class AlarmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
